'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n      font-weight: 600;\n    '], ['\n      font-weight: 600;\n    ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _colors = require('HubStyleTokens/colors');

var _HR = require('UIComponents/elements/HR');

var _HR2 = _interopRequireDefault(_HR);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _ProductCatalogModal = require('pricing-pages-unified-ui/components/product-catalog/ProductCatalogModal');

var _ProductCatalogModal2 = _interopRequireDefault(_ProductCatalogModal);

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledLink = (0, _styledComponents2.default)(_UILink2.default).withConfig({
  displayName: 'ViewAllFeatures__StyledLink'
})(['&.features-link{', '}'], _responsiveBreakpoints2.default.phone(_templateObject));

var ViewAllFeaturesContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ViewAllFeatures__ViewAllFeaturesContainer'
})(['position:absolute;bottom:12px;left:0;width:100%;text-align:center;hr{background-color:', ';margin-bottom:16px !important;}'], _colors.BATTLESHIP);

var ViewAllFeatures = function ViewAllFeatures(_ref) {
  var edition = _ref.edition,
      hub = _ref.hub,
      use = _ref.use,
      gaClassName = _ref.gaClassName;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isModalOpen = _useState2[0],
      setIsModalOpen = _useState2[1];

  var toggleViewAllFeaturesModal = function toggleViewAllFeaturesModal() {
    setIsModalOpen(!isModalOpen);

    if (!isModalOpen) {
      (0, _getUsageTracker2.default)().track('clickToViewModal', {
        name: 'compare-feature-modal',
        edition: edition,
        inCalculator: false
      });
    }
  };

  var ViewAllFeaturesContent = _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      StyledLink,
      {
        className: 'm-left-0 features-link ' + gaClassName,
        onClick: toggleViewAllFeaturesModal
      },
      _react2.default.createElement(_FormattedMessage2.default, {
        message: 'pricingPage.highlightedMerchCards.seeAllFeatures',
        className: gaClassName
      })
    ),
    isModalOpen && _react2.default.createElement(_ProductCatalogModal2.default, {
      hub: hub,
      onCloseClick: toggleViewAllFeaturesModal
    })
  );

  if (use === 'inline') {
    return ViewAllFeaturesContent;
  }

  return _react2.default.createElement(
    ViewAllFeaturesContainer,
    null,
    _react2.default.createElement(_HR2.default, { className: 'm-bottom-5' }),
    ViewAllFeaturesContent
  );
};

ViewAllFeatures.propTypes = {
  hub: _react.PropTypes.string.isRequired,
  edition: _react.PropTypes.string,
  gaClassName: _react.PropTypes.string.isRequired,
  use: _react.PropTypes.string
};

exports.default = ViewAllFeatures;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/ViewAllFeatures.js
// module id = 246
// module chunks = 3 4